import { render, staticRenderFns } from "./jiedaiXimei.vue?vue&type=template&id=5fccd292&scoped=true&"
import script from "./jiedaiXimei.vue?vue&type=script&lang=js&"
export * from "./jiedaiXimei.vue?vue&type=script&lang=js&"
import style0 from "./jiedaiXimei.vue?vue&type=style&index=0&id=5fccd292&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fccd292",
  null
  
)

export default component.exports